<template>
  <div>
    <div class="row">
      <div class="col-12">
        <custom-callout
          :border-color-hex="item.statusColor"
          class-main="mt-3 rounded"
          :controlled="true"
          :has-border="collapsable"
          :has-toggle="collapsable"
          :opened="item.isOpen"
          @click:open="
            () => {
              this.$emit('open-request-tab');
            }
          "
        >
          <validation-observer ref="interventionForm" novalidate tag="form">
            <div class="row py-4 mr-md-0">
              <div class="col-12 col-md-3 col-lg-3 col-xl-3 border-right">
                <div>
                  <div class="font-18 font-weight-bold">
                    <ul
                      class="status-aee m-0"
                      :style="variant(item.statusColor)"
                    >
                      <li>{{ item.status }}</li>
                    </ul>
                  </div>
                  <div class="color-black font-16 font-weight-bold">
                    {{ item.requestNumber }}
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-9">
                <div class="row pt-2">
                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 pl-4">
                    <div>
                      <span class="color-gray-6 d-block font-14">
                        Año Académico:
                      </span>
                      <span class="font-16 color-black">
                        {{ item.academicYear }}
                      </span>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 pl-4">
                    <div>
                      <span class="color-gray-6 d-block font-14">
                        Procedencia:
                      </span>
                      <span class="font-16 color-black">
                        {{ item.origin | empty }}
                      </span>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 pl-4">
                    <div>
                      <span class="color-gray-6 d-block font-14">
                        Intervenciones Adeudadas:
                      </span>
                      <span
                        v-if="editingInterventions"
                        class="font-16 color-black"
                      >
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                        >
                          <custom-input
                            v-model.number="editedInterventionValue"
                            custom-error-msg="La cantidad de intervenciones adeudadas es requeridas."
                            :error="errors[0]"
                            type="number"
                          />
                        </validation-provider>
                      </span>
                      <span v-else class="font-16 color-black">
                        {{ item.dueInterventions | empty }}
                      </span>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 pl-4">
                    <div>
                      <span class="color-gray-6 d-block font-14">
                        Intervenciones Ofrecidas:
                      </span>
                      <span class="font-16 color-black">
                        {{ item.offeredInterventions | empty }}
                      </span>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 pl-4">
                    <div>
                      <span class="color-gray-6 d-block font-14">
                        Balance Actual:
                      </span>
                      <span class="font-16 color-black">
                        {{ item.currentBalance | empty }}
                      </span>
                    </div>
                  </div>
                  <div
                    v-if="hasActions && !editingInterventions"
                    class="col-12 col-sm-2 col-md-12 col-lg-12 col-xl-2 d-inline d-md-flex align-items-center justify-content-end mt-2 mt-md-0"
                  >
                    <drop-down class="ml-2" :items="actionItems(item)" />
                  </div>
                  <div
                    v-if="editingInterventions"
                    class="col-12 col-sm-2 col-md-12 col-lg-12 col-xl-2 d-inline d-md-flex align-items-center justify-content-end mt-2 mt-md-0"
                  >
                    <div class="col-md-12">
                      <action-button
                        class="float-right"
                        i="fas fa-times-circle"
                        variant="outline-danger mb-4 mt-3"
                        @click="toggleEditInterventions"
                      />
                      <action-button
                        class="float-right mr-2"
                        i="fas fa-save fa-lg"
                        variant="success mt-3"
                        @click="saveInterventions"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </validation-observer>
          <template #edition>
            <div class="mt-1">
              <div class="bg-white rounded p-md-3 px-md-4">
                <custom-tab class="custom-tabs">
                  <custom-tab-item
                    :active="
                      item.viewToDisplay ===
                        viewDisplayEnum.ADDITIONAL_INFORMATION
                    "
                    lazy
                    title="Información Adicional"
                  >
                    <div class="ml-2 ml-md-5 ml-sm-2 mr-4 pb-3">
                      <div class="row mt-3">
                        <div class="col col-sm col-12 pt-2">
                          <em class="fas fa-info-circle text-orange mr-1" />
                          <span class="color-gray-7 font-16 font-weight-bold">
                            Información Adicional
                          </span>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 col-md-6 my-2">
                          <div class="color-gray-6 font-14">
                            Número de Solicitud:
                          </div>
                          <div class="color-black font-16">
                            {{ item.requestNumber | empty }}
                          </div>
                        </div>
                        <div class="col-12 col-md-6 my-2">
                          <div class="color-gray-6 font-14">
                            Fecha de Solicitud:
                          </div>
                          <div class="color-black font-16">
                            {{ item.requestedDate | date('DD/MMM/YYYY') }}
                          </div>
                        </div>
                        <div class="col-12 col-md-12 my-2">
                          <div class="color-gray-6 font-14">Comentario:</div>
                          <div class="color-black font-16">
                            {{ item.comment | empty }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </custom-tab-item>
                </custom-tab>
              </div>
              <div
                v-if="item.viewToDisplay === viewDisplayEnum.CLOSING_ANALYSIS"
                class="bg-white"
              >
                <validation-observer ref="requestForm" novalidate tag="form">
                  <section-title
                    class="mt-3"
                    content="Descripción del Servicio Compensatorio"
                    :has-line="false"
                    icon="fas fa-clipboard-list"
                    :reverse="true"
                  />

                  <div class="row">
                    <div class="col-12 col-md-12 my-2">
                      <div class="color-gray-6 font-14">Descripción:</div>
                      <div class="color-black font-16">
                        Reposición {{ item.academicYear | empty }}
                      </div>
                    </div>
                    <div class="col-12 col-md-4 my-2">
                      <div class="color-gray-6 font-14">
                        Intervenciones Adeudadas:
                      </div>
                      <div class="color-black font-16">
                        {{ item.currentBalance | empty }}
                      </div>
                    </div>
                    <div class="col-12 col-md-4 my-2">
                      <validation-provider
                        ref="visitCountPostRequest"
                        v-slot="{ errors }"
                        rules="required"
                      >
                        <div class="color-gray-6 font-14">
                          Cantidad compensada posterior a la radicación de la
                          planilla y previo a AEE:
                        </div>
                        <div class="color-black font-16">
                          <custom-input
                            v-model.number="model.visitCountPostRequest"
                            :custom-error-msg="
                              'La cantidad compensada posterior a la radicación es requeridas.'
                            "
                            :disabled="
                              readOnly ||
                                (item.countVisitPostRequest != null
                                  ? item.countVisitPostRequest > 0
                                  : false)
                            "
                            :error="errors[0]"
                            type="number"
                          />
                        </div>
                      </validation-provider>
                    </div>
                    <div class="col-12 col-md-4 my-2">
                      <validation-provider
                        ref="sesionesOfrecidas"
                        v-slot="{ errors }"
                        rules="required"
                      >
                        <div class="color-gray-6 font-14">
                          Sesiones Ofrecidas:
                        </div>
                        <custom-input
                          v-model.number="model.userSessionOffered"
                          :custom-error-msg="
                            'Las sesiones ofrecidas son requeridas.'
                          "
                          :disabled="readOnly"
                          :error="errors[0]"
                          type="number"
                        />
                      </validation-provider>
                    </div>
                    <div class="col-12 col-md-4 my-3">
                      <validation-provider v-slot="{ errors }" rules="required">
                        <label class="data-title mb-0" for="hasAdditionalVisit">
                          ¿Se adeudan intervenciones adicionales?
                        </label>
                        <custom-radio-button
                          v-model="model.hasAdditionalVisit"
                          container-class="p-0"
                          custom-error-msg="Favor marcar Sí o No."
                          :error="errors[0]"
                          :is-disabled="true"
                          is-inline
                          name="hasAdditionalVisit"
                          :options="closeQuestions"
                        />
                      </validation-provider>
                    </div>
                    <div class="col-12 col-md-4 my-3">
                      <div class="color-gray-6 font-14">
                        Sesiones que se adeuda:
                      </div>
                      <div class="color-black font-16">
                        {{ item.currentBalance | empty }}
                      </div>
                    </div>
                    <div class="col-12 col-md-4 my-3">
                      <validation-provider v-slot="{ errors }" rules="required">
                        <label
                          class="data-title mb-0"
                          for="isContinuedInAcademicYear"
                        >
                          ¿Se continuará compensando durante el año escolar?
                        </label>
                        <custom-radio-button
                          v-model="model.isContinuedInAcademicYear"
                          container-class="p-0"
                          custom-error-msg="Favor marcar Sí o No."
                          :error="errors[0]"
                          :is-disabled="readOnly"
                          is-inline
                          name="isContinuedInAcademicYear"
                          :options="closeQuestions"
                        />
                      </validation-provider>
                    </div>
                  </div>

                  <section-title
                    class="mt-3"
                    content="Indique la estrategia que utilizará durante el año escolar regular u otro medio"
                    :has-line="true"
                  />

                  <div v-for="strategy in item.strategies" :key="strategy.id">
                    <div
                      class="custom-control custom-checkbox custom-control-inline my-3"
                    >
                      <input
                        :id="`strategy-${strategy.id}`"
                        v-model="strategy.replacementStrategySelected"
                        class="custom-control-input"
                        :disabled="
                          strategy.disabled ||
                            item.isAnalysisCompleted ||
                            item.statusId ==
                              requestStatus.CompletadoPendientedeAprobacion
                        "
                        :name="`strategy-${strategy.id}`"
                        type="checkbox"
                        :value="strategy.id"
                        @input="onStrategySelect(strategy, strategy.id)"
                      />
                      <label
                        class="custom-control-label"
                        :for="`strategy-${strategy.id}`"
                      >
                        <span class="font-weight-bold fst-normal">
                          {{ strategy.name }}
                        </span>
                        -
                        <span>{{ strategy.description }}</span>
                      </label>
                    </div>
                  </div>
                  <div class="col-12">
                    <CompensatoryRequestDocs
                      v-model="model.documents"
                      :compensatory-request-id="item.compensatoryRequestId"
                      :documents="item.documentTypes"
                      :is-read-only="isReadOnly"
                      @on-download="onDownloadHandler"
                    />
                  </div>
                  <div v-if="hasSubmitActions" class="my-3">
                    <action-button
                      class="float-right ml-2"
                      :disabled="readOnly"
                      i="fas fa-flag"
                      text="Someter"
                      variant="outline-success"
                      @click="submitHandler"
                    />

                    <action-button
                      class="float-right mr-1"
                      :disabled="readOnly"
                      i="fas fa-save"
                      text="Guardar"
                      variant="success"
                      @click="saveHandler"
                    />
                  </div>
                </validation-observer>
              </div>
            </div>
            <div
              v-if="item.viewToDisplay === viewDisplayEnum.REJECT"
              class="rounded p-md-3 px-md-4"
            >
              <reject-request
                title="Rechazo de Solicitudes Compensatorias"
                :value="item"
                @on-cancel="$emit('on-open-close')"
                @on-save="$emit('on-save')"
              />
            </div>
            <div
              v-if="item.viewToDisplay === viewDisplayEnum.ACCEPT"
              class="rounded p-md-3 px-md-4"
            >
              <accept-request
                :submit-status-id="requestStatus.Aprobado"
                :title="'Razón de Aprobación'"
                :value="item"
                @on-cancel="$emit('on-open-close')"
                @on-save="$emit('on-save')"
              />
            </div>
            <div
              v-if="item.viewToDisplay === viewDisplayEnum.DOCUMENTS"
              class="rounded p-md-3 px-md-4"
            >
              <compensatory-service-documents
                :academic-year-id="item.academicYearId"
                :read-only="true"
                :request-id="item.requestId"
                :request-status-id="item.statusId"
              />
            </div>
          </template>
        </custom-callout>
      </div>
    </div>
  </div>
</template>

<script>
//constants
import DropDown from 'dropdown';
import CustomInput from 'CustomInput';
import CustomCallout from 'custom-callout';
import CustomRadioButton from 'custom-radio';
import SectionTitle from 'SectionTitle';
import ActionButton from 'ActionButton';
import RejectRequest from '@/views/provider/services-compensatory-management/components/RejectRequest.vue';
import AcceptRequest from '@/views/provider/services-compensatory-management/components/AcceptRequest.vue';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';
import compensatoryRequestStatus from '@/utils/constants/compensatoryRequestStatus';
import httpStatusCode from '@/utils/constants/httpStatusCode';
import viewDisplay from '@/utils/constants/compensatoryRequestView';
import { replacementStrategies } from '@/utils/constants/strategy';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import { downloadDocumentByAttachmentId as _downloadDocumentByAttachmentId } from '@/services/common/document.api.js';
import {
  saveClosingAnalysis as _saveClosingAnalysis,
  submitClosingAnalysis as _submitClosingAnalysis,
} from '@/services/provider/closing-analysis.api';

import { editInterventions } from '@/services/provider/compensatoryRequest.api';
import CompensatoryRequestDocs from '../CompensatoryRequestDocs.vue';
import CompensatoryServiceDocuments from '@/views/uspqrp/contract-management/components/tabs/CompensatoryServiceDocuments.vue';

export default {
  name: 'ContractRequestCompensatory',
  components: {
    ActionButton,
    CustomCallout,
    SectionTitle,
    DropDown,
    CustomTab,
    CustomTabItem,
    CustomInput,
    CustomRadioButton,
    ValidationObserver,
    ValidationProvider,
    CompensatoryRequestDocs,
    RejectRequest,
    AcceptRequest,
    CompensatoryServiceDocuments,
  },
  props: {
    item: {
      type: Object,
      default: () => () => ({}),
    },
    hasSubmitActions: {
      type: Boolean,
      default: () => false,
    },
    collapsable: {
      type: Boolean,
      default: () => true,
    },
    hasActions: {
      type: Boolean,
      default: () => true,
    },
    hasPermissionClosingAnalysis: {
      type: Boolean,
      default: () => false,
    },
    contract: {
      type: Object,
      default: () => ({}),
    },
    sameContext: {
      type: Boolean,
      default: () => false,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      model: {
        compensatoryRequestId: 0,
        hasAdditionalVisit: false,
        isContinuedInAcademicYear: false,
        userSessionOffered: null,
        visitCountPostRequest: null,
        strategyId: 0,
        strategies: [],
        documents: [],
        selectedStrategies: [],
      },
      editingDate: false,
      editingInterventions: false,
      editedInterventionValue: null,
      showRequestCompensatoryInfo: false,
      showClosingAnalysis: false,
      results: [],
      closeQuestions: [
        { label: 'Sí', value: true },
        { label: 'No', value: false },
      ],
      strategies: [
        {
          id: 1,
          title: 'Estrategia 1',
          description:
            'Estrategia 1 - Determinación de ofrecer la resta de las sesiones indicadas que aún no han sido provistas, aumentando la frecuencia a 1 sesión adicional por periodo de 3 meses, 6 meses o un año conforme se entienda a la necesidad del estudiante. Nota: Requiere enmienda al PEI para que se genere nuevo referido cuando esa diferencia excede la 20 sesiones. Las ofrecidas hasta que se logre enmendar el PEI, serán descontadas de la cantidad adeudada. Si al momento de enmendar el PEI se adeuda una cuantía menor a 20, se recomienda no enmendar y continuar documentando en sistema como reposición de año anterior. (Podrá considerar la opción 2 a su vez.)',
        },
        {
          id: 2,
          title: 'Estrategia 2',
          description:
            'Estrategia 2 - Identificación de recursos adicionales que en coordinación con el que sirve el estudiante (entre ellos el supervisor de la disciplina) colabore con el proveedor en el ofrecimiento de los servicios. Nota: Podría estar ligada a la determinación 1.',
        },
      ],
      showSubmitActions: false,
      documentTypeOptions: [],
    };
  },
  mixins: [alertMixin],
  computed: {
    actionItems() {
      return (item) => {
        return [
          {
            label: 'Ver Solicitud',
            icon: 'fas fa-file-import color-green',
            click: () => {
              this.$emit('open-request-tab', true);
              this.$emit('on-open-additional-info');
            },
            visible: true,
          },
          {
            label: 'Ver Documentos',
            icon: 'fas fa-file-search color-green',
            click: () => {
              this.$emit('open-request-tab', true);
              this.$emit('on-open-documents');
            },
            visible: true,
          },
          {
            label: 'Editar intervenciones adeudadas',
            icon: 'fas fa-file-edit color-green',
            click: this.toggleEditInterventions,
            visible: this.userHasPermissions(
              'rempro.provider.compensatoryrequest.editinterventionsdue'
            ),
          },
          {
            label: 'Ver Análisis de Cierre',
            icon: 'fas fa-file-import color-green',
            click: () => {
              this.$emit('open-request-tab', true);
              this.$emit('on-open-closing-analysis');
            },
            visible: this.hasPermissionClosingAnalysis,
          },
          {
            label: 'Análisis de Cierre',
            icon: 'fas fa-clipboard-list-check color-green',
            border: 'top',
            click: () => {
              this.$router.push({
                name: 'contractManagement',
                params: {
                  companyId: this.contract.companyId,
                  requestServiceId: this.contract.requestServiceId,
                  contractId: this.contract.contractId,
                  requestCompensatoryId: item.requestId,
                  toCloseAnalysis: true,
                },
              });
            },
            visible:
              !this.sameContext && this.analysisApply.includes(item.statusId),
          },
          {
            label: 'Aceptar',
            icon: 'fas fa-check-square color-green',
            visible: this.canViewAcceptCancel,
            click: () => {
              this.$emit('on-show-submit');
            },
          },
          {
            label: 'Rechazar Solicitud',
            icon: 'fas fa-solid fa-file-times color-red',
            click: () => {
              this.$emit('on-open-reject-request');
            },
          },
        ];
      };
    },
    variant() {
      return (statusColor) => {
        return {
          '--bg-color': statusColor,
        };
      };
    },
    requestStatus() {
      return compensatoryRequestStatus;
    },
    analysisApply() {
      return [
        this.requestStatus.Aprobado,
        this.requestStatus.CompletadoPendientedeAprobacion,
        this.requestStatus.ProcesoCompletado,
        this.requestStatus.DevueltoAProveedor,
        this.requestStatus.ExcluidoPorEstrategia,
      ];
    },
    canViewAcceptCancel() {
      return (
        this.item.statusId == compensatoryRequestStatus.EnProcesoDiscusion ||
        this.item.statusId == compensatoryRequestStatus.DevueltoAProveedor
      );
    },
    viewDisplayEnum() {
      return viewDisplay;
    },
    readOnly() {
      return this.isReadOnly;
    },
  },
  mounted() {
    this.onReadyComponent();
  },
  watch: {
    item() {
      this.onReadyComponent();
    },
  },
  methods: {
    toggleEditInterventions() {
      this.editingInterventions = !this.editingInterventions;
    },
    async saveInterventions() {
      if (this.editedInterventionValue > this.item.currentBalance) {
        this.ShowToast(
          'Alert',
          'Las intervenciones no pueden ser mayor al balance actual.',
          'error'
        );
        return;
      }

      const payload = {
        compensatoryRequestId: this.item.requestId,
        InterventionAmount: this.editedInterventionValue,
      };

      await editInterventions(payload)
        .then(() => {
          this.item.dueInterventions = this.editedInterventionValue;
          this.editedInterventionValue = null;
          this.toggleEditInterventions();
          this.ShowToast(
            'Proceso Exitoso.',
            'Las intervenciones fueron actualizadas exitosamente.',
            'success'
          );
        })
        .catch((err) =>
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          )
        );
    },
    downloadDocument(documentId) {
      if (documentId) {
        _downloadDocumentByAttachmentId(documentId).catch((err) => {
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          );
        });
      }
    },
    validateRequiredDocument(item) {
      if (this.request.requestId !== 0) {
        return item.isRequired && !item.filename;
      }
      return item.isRequired;
    },
    onPrepareFieldsAnalysisRequest() {
      this.model.compensatoryRequestId = this.item.requestId;
      this.model.strategies = this.item.strategies
        .filter((x) => x.replacementStrategySelected)
        .map((x) => x.id);
    },
    async saveHandler() {
      this.onPrepareFieldsAnalysisRequest();

      await _saveClosingAnalysis(this.model)
        .then(({ data }) => {
          if (data.statusCode == httpStatusCode.OK) {
            this.ShowToast(
              'Proceso Exitoso.',
              'Análisis de Cierre guardado exitosamente.',
              'success'
            );
            this.$emit('on-save');
          } else {
            this.ShowToast('Alerta', 'Ha ocurrido un error.', 'error');
          }
        })
        .catch(() => {
          this.ShowToast('Alerta', 'Ha ocurrido un error.', 'error');
        });
    },
    async submitHandler() {
      this.$refs['requestForm'].validate();
      this.onPrepareFieldsAnalysisRequest();
      if (
        this.item.strategies.filter((x) => x.replacementStrategySelected)
          .length == 0
      ) {
        this.ShowToast('Alerta', 'Debes seleccionar una estrategia.', 'error');
        return;
      }

      await _submitClosingAnalysis(this.model)
        .then(({ data }) => {
          if (data.statusCode == httpStatusCode.OK) {
            this.ShowToast(
              'Proceso Exitoso.',
              'Análisis de Cierre sometido exitosamente.',
              'success'
            );
            this.$emit('on-save');
          } else {
            this.ShowToast('Alerta', 'Ha ocurrido un error.', 'error');
          }
        })
        .catch(() => {
          this.ShowToast('Alerta', 'Ha ocurrido un error.', 'error');
        });
    },
    onUploadFileHandler(file, item) {
      item.content = file;
    },
    addDoc(idx) {
      this.$refs[`documentInputRef-${idx}`][0].$refs.fileuploadRef.click();
    },
    onReadyComponent() {
      this.model.userSessionOffered = this.item.sessionOffers;
      this.model.visitCountPostRequest = this.item.countVisitPostRequest;
      this.model.hasAdditionalVisit =
        this.item.hasAdditionalVisit != null
          ? this.item.hasAdditionalVisit
          : false;
      this.model.isContinuedInAcademicYear = this.item.isContinuedInAcademicYear;
      this.model.documents = this.item.documents
        ?.filter((doc) => doc.documentId)
        .map((dc) => {
          return {
            id: dc.documentId,
            attachment: {},
            documentTypeId: dc.documentTypeId,
            documentTypeDesc: dc.documentTypeName,
            filename: dc.filename,
          };
        });
      let currentStrategy = this.item?.strategies?.filter(
        (strategy) => strategy.value
      );
      if (currentStrategy) {
        this.model.strategyId = currentStrategy[0]?.id;
      }

      this.editedInterventionValue = this.item.dueInterventions;

      if (Array.isArray(this.item.checkStrategies)) {
        this.item.checkStrategies.forEach((s) => {
          var currentStrategy = this.item?.strategies?.find((x) => x.id == s);
          this.onStrategySelect(currentStrategy, currentStrategy.id);
        });
      }

      this.documentTypeOptions = this.item.documentTypes?.map((x) => ({
        id: x.documentTypeId,
        name: x.documentTypeName,
      }));
    },
    onStrategySelect(strategy, idx) {
      strategy.replacementStrategySelected = !strategy.replacementStrategySelected;
      if (strategy.replacementStrategySelected) {
        if (strategy.multipleChoiceFlag) {
          this.item.strategies.forEach((s) => {
            s.disabled = !s.multipleChoiceFlag ? true : false;
          });
        } else {
          this.item.strategies.forEach((s) => {
            s.disabled = true;
          });
        }

        strategy.disabled = false;

        if (
          strategy.id === replacementStrategies.Strategy1 ||
          strategy.id === replacementStrategies.Strategy2
        ) {
          this.item.strategies.forEach((s) => {
            const isEnabledStrategy = [
              replacementStrategies.Strategy1,
              replacementStrategies.Strategy2,
            ].includes(s.id);

            s.disabled = !isEnabledStrategy;
          });
        }
      } else {
        if (
          !this.item.strategies.some(
            (s) => s.multipleChoiceFlag && s.replacementStrategySelected
          )
        ) {
          this.item.strategies.forEach((s) => {
            s.disabled = false;
          });
        }
      }
      if (idx == 4 && this.isExceptionAcademicYear) {
        this.showABquestions = strategy.replacementStrategySelected;
      }

      //strategy 10 show comment
      if (idx == 9) {
        this.showComment = strategy.replacementStrategySelected;
      }
    },
    onDownloadHandler({ id }) {
      if (id) {
        _downloadDocumentByAttachmentId(id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.status-aee {
  list-style: none;
  padding-left: 20px;
}

.status-aee li {
  margin-bottom: 5px;
  position: relative;
}

.status-aee li::before {
  content: '•';
  color: var(--bg-color);
  position: absolute;
  left: -15px;
}
</style>
